import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { viewProfile } from "../store/auth/authSlice";

export const OpenRoutes = ({ children }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    if (user) {
      setIsAuthenticated(true);
      return;
    }

    const checkAuthentication = async () => {
      try {
        await dispatch(viewProfile()).unwrap();
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
      } finally {
      }
    };

    checkAuthentication();
  }, [dispatch, user]);

  return isAuthenticated ? <Navigate to="/" replace={true} /> : children;
};
